import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ComponentsModule } from '../../lib';
import { RBR_API_CONFIG, RbrApiConfig, createRoomByRoomService } from './rbr-api.config';
import { SectionComponent } from './shared';
import {
    CalculationBaseComponent,
    DefaultValuesComponent,
    LevelRoomsPanelComponent,
    RoomEditorComponent,
    RoomListComponent
} from './components';
import { RoomTypePipe, ValueWithUnitPipe } from './pipes';
import { RoomByRoomCalculatorComponent } from './components/room-by-room-calculator/room-by-room-calculator.component';
import { RoomByRoomApiService } from './services';

const COMPONENTS = [
    SectionComponent,
    CalculationBaseComponent,
    DefaultValuesComponent,
    RoomEditorComponent,
    RoomListComponent,
    LevelRoomsPanelComponent,
    RoomByRoomCalculatorComponent
];
const PIPES = [ValueWithUnitPipe, RoomTypePipe];

@NgModule({
    imports: [CommonModule, ComponentsModule, ...COMPONENTS, ...PIPES],
    exports: [...COMPONENTS, ...PIPES]
})
export class RoomByRoomModule {
    static forRoot(config: RbrApiConfig): ModuleWithProviders<RoomByRoomModule> {
        return {
            ngModule: RoomByRoomModule,
            providers: [
                {
                    provide: RBR_API_CONFIG,
                    useValue: config
                },
                {
                    provide: RoomByRoomApiService,
                    useFactory: createRoomByRoomService,
                    deps: [RBR_API_CONFIG, HttpClient]
                }
            ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: RoomByRoomModule, @Optional() http: HttpClient) {
        if (!http) {
            throw new Error('You need to import the HttpClient in your AppModule!');
        }
    }
}
